import { ExportIcon } from '@calendly/ui/components/icons';
import { useSelector, useDispatch } from 'react-redux';
import { exportEvents } from 'actions/scheduled_events/export';
import FilterListAction from 'components/scheduled_events/filter_list/action';
import { AllSchedulingMethods } from 'constants/meetings';
import { useHomeTabs } from 'hooks/home/tabs';
import { useFilters } from 'hooks/meetings/filters';
import { useLookupUuidsQuery } from './api';
import { mapMeetingsFilterParamsToExportParams, normalizeScheduledEventsExportScope } from './map_meetings_filter_params_to_export_params';
const exportButtonLabelCss = "esngpff";

/** Same scheduling_methods default as list search / useFilterParamsWithUuids. */
const filterDefaultsWithSchedulingMethods = filterDefaults => ({
  ...(filterDefaults || {}),
  scheduling_methods: filterDefaults?.scheduling_methods ?? AllSchedulingMethods
});
export const ExportButton = ({
  scope: scopeProp,
  text,
  filterDefaults
}) => {
  const dispatch = useDispatch();
  const isDisabled = useSelector(state => state.scheduled_events.export.loading);
  const {
    getTabScopeV2
  } = useHomeTabs();
  const {
    getFilterParams
  } = useFilters();
  const filterParams = getFilterParams(filterDefaultsWithSchedulingMethods(filterDefaults));
  const {
    data: lookupUuids
  } = useLookupUuidsQuery({
    filters: filterParams
  });
  const tabScope = getTabScopeV2();
  const exportScope = normalizeScheduledEventsExportScope(tabScope.type ?? scopeProp?.type, tabScope.id ?? scopeProp?.id);
  const handleExport = () => {
    const hydratedParams = lookupUuids ? {
      ...filterParams,
      ...lookupUuids
    } : filterParams;
    dispatch(exportEvents(mapMeetingsFilterParamsToExportParams(hydratedParams), exportScope));
  };
  return <FilterListAction decoration="minimal" isDisabled={isDisabled} onClick={handleExport}>
      <ExportIcon />
      {text != null && <span className={exportButtonLabelCss}>
          {text}
        </span>}
    </FilterListAction>;
};

require("./export_button.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./export_button.js");